import { Button } from "antd";
import React from "react";

const BannerButton = ({ title, icon,onClick }) => {
  return (
    <Button type="primary" className="btn btn-danger" onClick={onClick}>
      {title} {icon}
    </Button>
  );
};

export default BannerButton;
